export default "/_nuxt/c80e61a6771d526ff92a7aaa93d5df8c.svg";